/**
 * Chỉ số dẫn xuất — tính từ dữ liệu trong bộ nhớ bằng finance-core, memo theo
 * đúng collection phụ thuộc. KHÔNG fetch lại, KHÔNG công thức riêng ở UI.
 */
import { useMemo } from 'react';
import {
  balanceSheet, emergencyFundBalance, liquidBalance, essentialMonthlyExpense, userFinancialMetrics,
  healthRatios, healthScore, monthlyDebtLoad, monthlySeries
} from '../../finance';
import { useData } from './data';

export const useBalanceSheet = () => {
  const sources = useData(s => s.data.sources);
  const debts = useData(s => s.data.debts);
  return useMemo(() => balanceSheet(sources, debts), [sources, debts]);
};

export const useMetrics = () => {
  const incomes = useData(s => s.data.incomes);
  const expenses = useData(s => s.data.expenses);
  return useMemo(() => userFinancialMetrics(incomes, expenses), [incomes, expenses]);
};

/** Tháng hiện tại (chưa kết thúc): thu, chi có dấu, còn lại. */
export const useThisMonth = () => {
  const incomes = useData(s => s.data.incomes);
  const expenses = useData(s => s.data.expenses);
  return useMemo(() => monthlySeries(expenses, incomes, 1)[0], [incomes, expenses]);
};

export const useHealth = () => {
  const sources = useData(s => s.data.sources);
  const debts = useData(s => s.data.debts);
  const expenses = useData(s => s.data.expenses);
  const expenseCategories = useData(s => s.data.expenseCategories);
  const sheet = useBalanceSheet();
  const m = useMetrics();
  return useMemo(() => {
    const essential = essentialMonthlyExpense(expenses, Object.fromEntries(expenseCategories.map((c: any) => [c.name, c.budgetClass === 'need' ? 'need' : 'want'])));
    const emergencyFund = emergencyFundBalance(sources, liquidBalance(sources));
    const ratios = healthRatios({
      avgMonthlyIncome: m.avgMonthlyIncome,
      avgMonthlyExpense: m.avgMonthlyExpense,
      essentialMonthlyExpense: essential,
      emergencyFund,
      monthlyDebtPayment: monthlyDebtLoad(debts, sources),
      totalAssets: sheet.totalAssets,
      totalLiabilities: sheet.totalLiabilities
    });
    return { ratios, score: healthScore(ratios), emergencyFund, monthsOfData: m.monthsOfData };
  }, [sources, debts, expenses, expenseCategories, sheet, m]);
};
